import {Outlet} from "react-router-dom";
import {Box} from "@mui/material";

const PortPluginPage = () => {

    return (
        <Box>
            <Outlet />
        </Box>
    )
}

export default PortPluginPage